import clsx, { type ClassArray } from 'clsx';
import { twMerge } from 'tailwind-merge';

const classNames = (...classes: ClassArray) => twMerge(clsx(...classes));

export default classNames;
